module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av741-c1e761ccc48540d83ea39a5ec1b0b11f.jpg";